import { useState } from 'react';

const SearchSelectBox = ({ list, name, setvalue, searchTerm: externalSearchTerm, setSearchTerm: setExternalSearchTerm }) => {
    // Fallback to internal state if not provided
    const [internalSearchTerm, setInternalSearchTerm] = useState('');
    const searchTerm = externalSearchTerm !== undefined ? externalSearchTerm : internalSearchTerm;
    const setSearchTerm = setExternalSearchTerm !== undefined ? setExternalSearchTerm : setInternalSearchTerm;

    const [showOptions, setShowOptions] = useState(false);

    const filteredVendors = list?.filter((vendor) =>
        vendor.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSelect = (name) => {
        setSearchTerm(name);
        setvalue(name);
        setShowOptions(false);
    };

    return (
        <div className="custom-date-wrapper position-relative">
            <label style={{ fontSize: "0.8rem", color: "#212529a6",padding:'0.1rem 0.3rem' }} htmlFor="fieldInput">
                {name}
            </label>
            <input
                type="text"
                className="form-control custom-date-input"
                id="fieldInput"
                onBlur={() => {
                    setTimeout(() => {
                        setShowOptions(false);
                    }, 500);
                }}
                placeholder={name}
                style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '30px' }}
                value={searchTerm}
                onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setShowOptions(true);
                }}
                onFocus={() => setShowOptions(true)}
                autoComplete="off"
            />
            {showOptions && (
                <ul className="dropdown-menu show w-100 mt-1">
                    {filteredVendors.length > 0 ? (
                        filteredVendors.map((vendor, index) => (
                            <li key={index}>
                                <button
                                    className="dropdown-item-custom"
                                    type="button"
                                    onClick={() => handleSelect(vendor.name)}
                                    style={{ fontSize: '0.8rem' }}
                                >
                                    {vendor.name}
                                </button>
                            </li>
                        ))
                    ) : (
                        <li className="dropdown-item text-muted" style={{ fontSize: '0.8rem' }}>
                            No results found
                        </li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default SearchSelectBox;
